module.exports = __webpack_public_path__ + "static/media/about-me.0391bdd6.png";